<template>
	<header>
		<nav>
			<h1><router-link to="/">BioMaLL Online</router-link></h1>
			<ul>
				<li><router-link to="/add" exact>Add Job</router-link></li>
				<li><router-link to="/" exact>View Jobs</router-link></li>
				<li><router-link to="/about" exact>About</router-link></li>
				<li><router-link to="/guide" exact>Dev Guide</router-link></li>
			</ul>
		</nav>
	</header>
</template>
<script>
export default{}
</script>
<style scoped>
header {
	margin-bottom: var(--gap-huge);
}
nav {
	overflow: auto;
}
nav > h1, nav li {
	float: left;
  margin-right: var(--gap);
  margin-bottom: var(--gap);
}
nav > ul {
	float: right;
}
nav ul {
	margin: 0;
	padding: 0;
	list-style: none;
}
nav li a {
	border-radius: 50px;
	display: block;
	border: 2px solid transparent;
	padding: var(--gap);
}
nav li a:hover, nav li a:focus {
	border-color: var(--accent-light);
	box-shadow: 5px 5px 0 var(--shadow);
	text-shadow: -1px -1px 0 var(--shadow),
		1px 1px 0 white;
}
nav li a.router-link-active {
	color: var(--canvas-light);
	background: var(--accent);
	border-top-color: var(--accent-light);
	border-bottom-color: var(--accent-dark);
	text-shadow: none;
}
nav li a.router-link-active:hover {
	text-shadow: -2px -2px 2px var(--accent-dark),
		2px 2px 2px var(--accent-light);
}
</style>
